import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

export type RawLearningBlock = {
  id: string;
  sessionNumber: number;
  title: string;
  itemIds: string[];
  estimatedDuration?: number;
  currentItemId?: string;
};

export type TimeCommitment = 15 | 30 | 45 | 60;

export const DEFAULT_TIME_COMMITMENT: TimeCommitment = 30;

export const TIME_COMMITMENT_OPTIONS: { minutes: number; label: string; recommended?: boolean }[] = [
  { minutes: 15, label: 'Quick session' },
  { minutes: 30, label: 'Moderate session' },
  { minutes: 45, label: 'Moderate session' },
  { minutes: 60, label: 'Recommended session', recommended: true },
];

export type LearningPace = 'guided' | 'low' | 'high';

export const DEFAULT_LEARNING_PACE: LearningPace = 'low';

export const LEARNING_PACE_TO_INDEX: Record<LearningPace, 0 | 1 | 2> = {
  guided: 0,
  low: 1,
  high: 2,
};

export const INDEX_TO_LEARNING_PACE: readonly LearningPace[] = ['guided', 'low', 'high'];

/**
 * Raw block item shape as it comes off the adaptive-learning GraphQL session plans (snake_case),
 * also the shape we send back to Coach via `additionalContext.currentLearningBlock`.
 */
export type RawBlockItem = {
  item_id: string;
  item_type?: string;
  item_name?: string;
  sub_skill_name?: string;
  skill_name?: string;
  bloom_categories?: string[];
};

export type BlockItem = {
  itemId: string;
  itemType?: string;
  itemName?: string;
  subSkillName?: string;
  skillName?: string;
  bloomCategories?: string[];
  itemMetadata: ItemMetadata;
};

export type LearningBlock = RawLearningBlock & {
  items: BlockItem[];
};

export const AI_GENERATED_ROUTE_PREFIX = '/ai-generated/';

export type AdaptiveLearningPlan = {
  blocks: LearningBlock[];
  timeCommitment: TimeCommitment;
  currentItemId?: string;
};
